The identifier of this advertisement product.

Identifiers may become stale, and should not be stored for long periods.

It would be appropriate to save an identifier for use in a job ad draft, but not for use as a job ad template.
